import { IFINotifications } from '../../../cimsPage/instances/ifi'
import { Notifications } from '../../common'

const { Edit, View } = Notifications({
  page: IFINotifications,
  view: 'B59159DC-1FD7-44FF-B6CC-F10453FFA6D9',
  edit: '249235B2-F8BB-4086-A38A-4F9F09C1E706',
})

export const ViewIFINotification = View
export const EditIFINotification = Edit

export type IFINotificationPermission =
  | typeof ViewIFINotification
  | typeof EditIFINotification
